<template>
<!-- en este template cambiamos el icon burguer por arrows para abrir y cerrar el meun lateral screen para students, 
uno igual se usa en la screen para tutores-->
  <div class="d-flex align-items-center">
    <div id="menu" :class="{ open: !sidebar.isCollapsed }" @click="onToggleSidebar">
       <i :class="iconOpen" aria-hidden="true" v-if="roles.includes('student')"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MenuIcon',
   data(){
   return{
    iconOpen:"fa fa-chevron-left"
   }
  },
  computed: {
    ...mapGetters({
      sidebar: 'app/sidebar',
      roles: 'auth/roles',
    }),
  },
  methods: {
    onToggleSidebar() {
      this.toggleSidebar();
       if( this.sidebar.isCollapsed===true){
         this.iconOpen="fa fa-chevron-left"
         }else{
       this.iconOpen="fa fa-chevron-right"
     }
    },
    ...mapActions({
      toggleSidebar: 'app/TOGGLE_SIDEBAR',
    }),
  },
};
</script>

<style lang="scss" scope>
@mixin windowsIconValue{
  color: rgba($color: #FFF, $alpha: 0.7);
  line-height: 2rem;
  font-size: 1.4rem;
  cursor: pointer;
  &:hover{
    color: white;
  }
}

#menu{
  @include windowsIconValue();
}
.windows{
  @include windowsIconValue();
}
</style>
